import { GlobalToken } from 'antd';
import styled from 'styled-components';

interface ContainerProps {
  width: number;
  height: number;
  $mapView: number;
  theme: { token: GlobalToken };
  $textColor: string;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: ${({ theme: { token } }) => token.paddingLG}px 0px 0 ${({ theme: { token } }) => token.paddingXXS}px;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${({ $mapView }) => $mapView};
  }

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ $textColor }) => $textColor};
    text-transform: capitalize;
    text-align: center;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }

  header {
    padding-left: ${({ theme: { token } }) => token.paddingSM}px;
    padding-top: ${({ theme: { token } }) => token.paddingXS}px;
    width: 60%;
    display: flex;
    align-items: center;

    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }

  section {
    .main-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 110px;

      .measurement-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .measurement-item {
          display: flex;
          justify-content: center;
          align-items: center;

          .value {
            font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
            font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
          }

          .label {
            font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
            color: ${({ theme: { token } }) => token.colorTextSecondary};
            margin-left: ${({ theme: { token } }) => token.marginXXS}px;
          }
        }
      }
    }
  }
`;
